/* istanbul ignore file */
/**
 * Provides store for application wide information
 *
 * @packageDocumentation
 */
export { createResourceRegistry } from './resource-registry.js';
export { registerLibrary, getLibraries, getLibrary } from './library-registry.js';
export { registerMFE, getMFE, getMFEs } from './mfe-registry.js';
export { setAppConfig, getAppConfig } from './app.js';
import { registerLibrary } from './library-registry.js';
registerLibrary({
    name: '@onviobr/app-information',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    version: "1.0.4",
});
